import React from 'react';
import AcademicPeriod from './AcademicPeriod';
import MonthsList from './MonthsList';
import YearsList from './YearsList';

const Dates = ({
  years,
  months,
  onSetYear,
  onMonth,
  onPeriod,
  period,
  selectedYear,
  selectedMonth,
}) => {
  return (
    <>
      <YearsList
        data={years}
        onSetYear={onSetYear}
        selectedYear={selectedYear}
      />
      {selectedYear && (
        <MonthsList
          data={months}
          onMonth={onMonth}
          selectedMonth={selectedMonth}
        />
      )}
      {selectedMonth && <AcademicPeriod data={period} onPeriod={onPeriod} />}
    </>
  );
};

export default Dates;
